"use strict";
/*
  Vereign Seal integration library. Copyright (C) 2020-2021 Vereign AG

  This program is free software: you can redistribute it and/or modify it under the terms of the GNU Affero General
  Public License as published by the Free Software Foundation, either version 3 of the License, or (at your option)
  any later version.

  This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY; without even the implied
  warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
  details.

  You should have received a copy of the GNU Affero General Public License along with this program. If not, see
  https://www.gnu.org/licenses/.

  In case of queries or questions, please contact us under by email under contact@vereign.com or by letter post to
  Vereign AG, Kolinplatz 10, 6300 Zug, Switzerland
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSealTemplate = exports.SRC_PLACEHOLDER = exports.SEAL_IMAGE_ALT = exports.SEAL_IMAGE_PREFIX = exports.SEAL_CONTAINER_PREFIX = void 0;
// https://code.vereign.com/seal/documentation/-/merge_requests/26
exports.SEAL_CONTAINER_PREFIX = "seal-container-v1-";
exports.SEAL_IMAGE_PREFIX = "seal-image-";
// TODO: Point out importance of the constant image alt for MIME normalisation
exports.SEAL_IMAGE_ALT = "Vereign Seal";
exports.SRC_PLACEHOLDER = "__src-placeholder__";
const getSealTemplate = (sealId, sealUrl) => {
    return `<a id=${exports.SEAL_CONTAINER_PREFIX}${sealId} href="${sealUrl}" target="_blank" rel="noopener noreferrer"><img id="${exports.SEAL_IMAGE_PREFIX}${sealId}" alt="${exports.SEAL_IMAGE_ALT}" src="${exports.SRC_PLACEHOLDER}"></a>`;
};
exports.getSealTemplate = getSealTemplate;
